// Layer 3 (Transformation) — the flagged risks beside the heat map: score 9
// and above, by score, budget US$ breaking ties. Pure.

import { FAILURE_MODES } from '@/versions/v1/shared/bunker-hill-advisory-seed';
import { RISK_ENTRIES } from './seed';
import { budgetImpact, riskBandLabel, riskScore, type RiskBand } from './Scene.transform';

export type RiskFlag = {
  id: string;
  /** 1-based rank by score (budget US$ breaks ties); rank 1 takes the crimson numeral. */
  rank: number;
  bandLabel: string;
  ownerTeam: string;
  label: string;
  controlMeasure: string;
  score: number;
  dollars: number;
  band: Extract<RiskBand, 'high' | 'critical'>;
  tone: 'danger' | 'warning';
  failureModeLabel?: string;
};

export function riskFlags(): readonly RiskFlag[] {
  return RISK_ENTRIES.map((risk) => {
    const scored = riskScore(risk);
    return { risk, scored, dollars: budgetImpact(risk).dollars };
  })
    .filter((row) => row.scored.score >= 9)
    .sort((left, right) => {
      if (right.scored.score !== left.scored.score) {
        return right.scored.score - left.scored.score;
      }
      return right.dollars - left.dollars;
    })
    .map((row, index) => {
      const band: Extract<RiskBand, 'high' | 'critical'> =
        row.scored.band === 'critical' ? 'critical' : 'high';
      const failureMode = row.risk.failureModeId
        ? FAILURE_MODES.find((mode) => mode.id === row.risk.failureModeId)
        : undefined;
      return {
        id: row.risk.id,
        rank: index + 1,
        bandLabel: riskBandLabel(band),
        ownerTeam: row.risk.ownerTeam,
        label: row.risk.label,
        controlMeasure: row.risk.controlMeasure,
        score: row.scored.score,
        dollars: row.dollars,
        band,
        tone: band === 'critical' ? 'danger' : 'warning',
        failureModeLabel: failureMode?.failureMode,
      };
    });
}
